import axios from 'axios'
import { createApp } from 'vue'
import qrcode from 'qrcode-generator'

const ID_COLLECTION_CATALOG = 'js-collectionCatalog'

document.addEventListener('DOMContentLoaded', async () => {
  const elementCollectionCatalog = document.getElementById(
    ID_COLLECTION_CATALOG
  )
  if (!elementCollectionCatalog) return

  const dataset = elementCollectionCatalog.dataset
  const collectionId = `gid://shopify/Collection/${dataset.collectionId}`
  const storefrontAccessToken = dataset.storefrontAccessToken
  const shopUrl = dataset.shopUrl

  if (!storefrontAccessToken) return

  const { data } = await axios.post(
    '/api/unstable/graphql.json',
    {
      query: `
      {
        collection(id: "${collectionId}") {
          handle
          products(first: 250) {
            edges {
              node {
                id
                featuredImage {
                  url
                }
                handle
                imageCatalog: metafield(namespace: "additional", key: "catalog_image") {
                  reference {
                    ... on MediaImage {
                      image {
                        url
                      }
                    }
                  }
                }
                size: metafield(namespace: "additional", key: "size") {
                  value
                }
                catalogSize: metafield(namespace: "additional", key: "catalog_size") {
                  value
                }
                tags
                catalogColor: metafield(namespace: "additional", key: "catalog_color") {
                  value
                }
                title
                catalogTitle: metafield(namespace: "additional", key: "catalog_title") {
                  value
                }
                price: variants(first: 1) {
                  edges {
                    node {
                      price {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
                catalogVariants: metafield(namespace: "catalog", key: "variants") {
                  value
                }
              }
            }
          }
        }
      }`,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
    }
  )
  const getColorTextFromTags = (tags) => {
    const colorTags = tags?.filter((tag) => tag.startsWith('カラー:')) || []
    if (colorTags.length === 0) return undefined
    return colorTags
      .reverse()
      .map((tag) => tag.replace('カラー:', ''))
      .join('×')
  }
  const products = await Promise.all(
    data.data.collection.products.edges
      .filter((edge) => !edge.node.tags?.includes('algolia-ignore'))
      .map(async (edge) => {
        const size = (
          edge.node.catalogSize?.value ||
          edge.node.size?.value ||
          ''
        )
          .split('<br>')
          .filter((v) => v)
          .join('<br>')
        const colorText =
          edge.node.catalogColor?.value || getColorTextFromTags(edge.node.tags)
        const price =
          Number.parseInt(edge.node.price.edges[0].node.price.amount, 10) || 0
        const image =
          edge.node.imageCatalog?.reference.image.url ||
          edge.node.featuredImage?.url
        const priceText = `¥${price.toLocaleString()}(税込)`
        const title = edge.node.catalogTitle?.value || edge.node.title
        const url = `${shopUrl}/products/${edge.node.handle}`
        let catalogVariants = []
        if (edge.node.catalogVariants?.value) {
          const productIds = edge.node.catalogVariants.value
            .split(',')
            .map((v) => v.trim())
            .filter((v) => v)
          const ids = productIds.map(
            (productId) => `gid://shopify/Product/${productId}`
          )
          try {
            const { data: nodesData } = await axios.post(
              '/api/unstable/graphql.json',
              {
                query: `{
                  nodes(ids: [${ids.map((id) => `"${id}"`).join(',')}]) {
                    ... on Product {
                      handle
                      featuredImage { url }
                      imageCatalog: metafield(namespace: "additional", key: "catalog_image") {
                        reference {
                          ... on MediaImage { image { url } }
                        }
                      }
                      tags
                      catalogColor: metafield(namespace: "additional", key: "catalog_color") {
                        value
                      }
                    }
                  }
                }`,
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                },
              }
            )
            if (!nodesData.data.nodes) throw new Error('nodes is null')
            catalogVariants = nodesData.data.nodes.map((product) => ({
              handle: product?.handle,
              image:
                product?.imageCatalog?.reference?.image?.url ||
                product?.featuredImage?.url,
              colorText:
                product?.catalogColor?.value ||
                getColorTextFromTags(product?.tags),
            }))
          } catch (e) {
            console.error(e)
            catalogVariants = []
          }
        }
        return {
          ...edge.node,
          image,
          size,
          priceText,
          title,
          url,
          catalogVariants,
          colorText,
        }
      })
  )
  const setQrCode = (element, url) => {
    const qr = qrcode(4, 'L')
    qr.addData(url)
    qr.make()
    element.innerHTML = qr.createSvgTag({
      margin: 0,
      scalable: true,
    })
  }

  createApp({
    name: 'TemplatesCollectionCatalog',
    data() {
      return { products }
    },
    mounted() {
      const elementCollectionQr = document.getElementById('collectionQr')
      const url = elementCollectionQr.dataset.url
      setQrCode(elementCollectionQr, url)

      const elementsQr = this.$refs.qr || []
      Array.from(elementsQr).forEach((elementQr) => {
        const url = elementQr.dataset.url
        setQrCode(elementQr, url)
      })
    },
  }).mount(elementCollectionCatalog)
})
